var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("YOU ARE ON THE USER PAGE:")]),_c('h2',[_vm._v("USER HOME")]),_c('h2',[_vm._v("Logged in as:")]),_c('h2',[_vm._v(_vm._s(_vm.$route.params.userId))])])}
var staticRenderFns = []

export { render, staticRenderFns }